import { ChakraProvider } from '@chakra-ui/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { EventStore } from './analytics/EventStore';
import { ErrorBoundary } from './components/ErrorBoundary';
import { DataProvider } from './context/DataContext';
import { supabase } from './data/init';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { theme } from './theme';

EventStore.get().initialize();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <DataProvider supabase={supabase}>
        <ChakraProvider theme={theme}>
          <App />
        </ChakraProvider>
      </DataProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
